import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/util/services/auth.service';
import { TokenStorageService } from 'src/app/util/services/token-storage.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoginDescriptionComponent } from './login-description/login-description.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];
  returnUrl = '';
  loading = false;
  shakeIt = false;
  loginFailed = false;

  constructor(
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().roles;
      if (this.roles.includes('ROLE_USER')){
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/user-panel/tools/list-tools';
      }
      if (this.roles.includes('ROLE_MANAGER')){
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/manager-panel/bookings';
      }
      if (this.roles.includes('ROLE_ADMIN')){
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin-panel/register/list-manager';
      }
      this.router.navigate([this.returnUrl]);
    }

  }

  openDialog() {
    const dialogRef = this.dialog.open(LoginDescriptionComponent, {
      width: '350px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  onSubmit() {
    this.loading = true;
    this.authService.login(this.loginForm.value).subscribe(
      data => {
        this.tokenStorage.saveToken(data.accessToken);
        this.tokenStorage.saveUser(data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        //this.router.navigateByUrl(this.returnUrl);
        this.reloadPage();
      },
      err => {
        this.loginFailed = true;
        if (err.status == '401'){
          this.shakeIt = true;

          this.loginForm.reset();
          setTimeout((arg) => {
            this.shakeIt = false;
          },
          500);

        }
        this.errorMessage = err.error.message;
        this.isLoginFailed = true;
        this.loading = false;
      }
    );
  }

  reloadPage() {
    window.location.reload();
  }

  public getError(controlName: string): string {
    let error = '';
    const control = this.loginForm.get(controlName);
    if (control.touched && control.errors != null) {
      error = JSON.stringify(control.errors);
    }
    return error;
  }

}
